export default __webpack_public_path__ + "static/media/pizza.3319f937.png";